/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */

const laggards = {
  	index: 		r => require.ensure([], () => r(require('./components/laggards')), 'recipient-bundle'),
	edit: 	r => require.ensure([], () => r(require('./components/edit')), 	'recipient-bundle'),
};


export default [
    {
		name: 'laggards',
		path: '/laggards',
		component: laggards.index,
    },
    {
		name: 'laggards.edit',
		path: '/laggards/:id',
		component: laggards.edit,
    }
]




// WEBPACK FOOTER //
// ./src/app/laggards/routes.js